import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';

const mapIndex = R.addIndex(R.map);

const Table = ({ rows }) => (
  <table className="table">
    <tbody>
      {/* build table iterating over rows and then cells */}
      {mapIndex(
        (row, rowIndex) => (
          <tr className="table__row" key={rowIndex}>
            {mapIndex(
              (cell, cellIndex) =>
                rowIndex === 0 ? (
                  <th className="table__head-cell" key={cellIndex}>
                    {cell}
                  </th>
                ) : (
                  <td className="table__cell" key={cellIndex}>
                    {cell}
                  </td>
                ),
              R.propOr([], 'cell', row)
            )}
          </tr>
        ),
        rows
      )}
    </tbody>
  </table>
);

Table.propTypes = {
  rows: PropTypes.instanceOf(PropTypes.array).isRequired,
};

export default Table;
